import { useRoute } from '#app'

export const useIsPreview = () => {
    const route = useRoute()

    return !!route.meta.preview
}
